import Vue from 'vue';

import * as Sentry from '@sentry/browser';
import { Vue as SentryVue } from '@sentry/integrations';

Sentry.init({
  dsn: 'https://df98a66cbacc4a0890b0013b89cc22c4@bugsink.slideslive.dev/4',
  release: __COMMIT_HASH__,
  integrations: [
    new SentryVue({
      Vue,
      tracing: false,
      logErrors: true,
    }),
  ],
  environment: process.env.NODE_ENV,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
